export const getMediaName = item => {
  if (!item) return '';
  if (item.name) return item.name;
  const url = item.url || '';
  return url.substring(url.lastIndexOf('/') + 1) || 'Untitled media';
};

// The API has used both an explicit folder flag and a folder mime/type in
// different versions. Keep this tolerant so older tenants still render.
export const isMediaFolder = item => {
  if (!item) return false;
  return (
    item.is_folder === true ||
    item.folder === true ||
    item.type === 2 ||
    item.type === 'folder' ||
    item.mime_type === 'folder' ||
    (item.url == null && item.name != null)
  );
};

const getMediaExtension = item => {
  const name = getMediaName(item).split('?')[0];
  const extension = name.substring(name.lastIndexOf('.') + 1);
  return extension === name ? '' : extension.toLowerCase();
};

export const isMediaImage = item =>
  Boolean(item?.mime_type?.startsWith('image/')) ||
  ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'heic', 'heif', 'avif'].includes(
    getMediaExtension(item),
  );

export const isMediaVideo = item =>
  Boolean(item?.mime_type?.startsWith('video/')) ||
  ['mp4', 'webm', 'mov', 'm4v', 'ogv', 'avi', 'm3u8'].includes(getMediaExtension(item));

export const isMediaAudio = item =>
  Boolean(item?.mime_type?.startsWith('audio/')) ||
  ['mp3', 'wav', 'ogg', 'oga', 'm4a', 'aac', 'flac'].includes(getMediaExtension(item));

export const isMediaPdf = item =>
  item?.mime_type === 'application/pdf' || getMediaExtension(item) === 'pdf';

export const isMediaCsv = item =>
  item?.mime_type === 'text/csv' ||
  item?.mime_type === 'application/csv' ||
  getMediaExtension(item) === 'csv';

export const getMediaTypeLabel = item => {
  if (isMediaFolder(item)) return 'Folder';
  const mime = item?.mime_type || '';
  if (mime.startsWith('image/')) return 'Image';
  if (isMediaVideo(item)) return 'Video';
  if (isMediaAudio(item)) return 'Audio';
  if (isMediaPdf(item)) return 'PDF';
  if (isMediaCsv(item)) return 'CSV';
  if (mime.includes('json')) return 'JSON';
  if (mime.includes('spreadsheet') || mime.includes('csv')) return 'Spreadsheet';
  return 'File';
};

export const getMediaTimestamp = item =>
  item?.created_at || item?.updated_at || item?.createdAt || 0;

export const getMediaSize = item => {
  const bytes = Number(item?.size_bytes || item?.size || item?.file_size || 0);
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
